import { useRequestMedicalContext } from '../../Contexts/RequestMedicalTestContext';
import RenderProcedures from '../../Components/ProceduresRender';
import * as ScrollArea from "@radix-ui/react-scroll-area";
import { ScrollBar } from '../../Components/ScrollBar';
import { Checkbox } from '@mui/material';
import { CheckBoxOutlineBlankOutlined, CheckBoxOutlined } from '@mui/icons-material';

function ListContent() {

    const {
        setSelectedProcedureClass,
        selectedProcedureClass,
        procedureClass,
        files
    } = useRequestMedicalContext();

    //via fileupload flow
    const handleProcedureClass = (data) => {
        const isSelected = selectedProcedureClass?.some(
            (procedure) => procedure.name === data.name
        );

        if (isSelected) {
            // If already selected, remove it
            setSelectedProcedureClass((prevProcedures) =>
                prevProcedures.filter((procedure) => procedure.name !== data.name)
            );
        } else {
            // If not selected, add it with date and time
            const newData = { ...data, date: undefined, time: undefined };
            setSelectedProcedureClass((prevProcedures) => [
                ...prevProcedures,
                newData,
            ]);
        }
    };

    let pcListContent = null;
    if(procedureClass.length>0){
        pcListContent = procedureClass.map((data) => {
        return (
            <div key={data.name} className="flex flex-row my-2">
                <label id="labl" className="w-full mt-1">
                    <input
                        name="procedures"
                        type="checkbox"
                        onChange={() => handleProcedureClass(data)}
                        checked={selectedProcedureClass?.some(
                            (procedure) => procedure.name === data.name
                        )}
                    />
                    <div
                    className={`flex w-full text-sm p-3 border rounded-lg`}
                    >
                    <div>
                        <Checkbox
                            icon={<CheckBoxOutlineBlankOutlined />}
                            checkedIcon={<CheckBoxOutlined />}
                            sx={{
                                padding: 0,
                                "&.Mui-disabled": {
                                color: "#0947AB",
                                },
                                "&.Mui-checked": {
                                color: "#0947AB",
                                },
                            }}
                            onChange={() => handleProcedureClass(data)}
                            checked={selectedProcedureClass?.some(
                                (procedure) => procedure.name === data.name
                            )}
                        />
                    </div>
                    <div className="pl-1">
                        <p>
                        {data.name.substring(
                            data.name.indexOf(":") + 1
                        )}
                        </p>
                    </div>
                    </div>
                </label>
            </div>
            );
        })
    }else{
        pcListContent = (
        <div className="p-5 flex flex-col items-center justify-center">
            <p className="text-sm text-[#60656D]">No procedure class found.</p>
        </div>
        );
    }

    let content = null;
    if(files.length > 0) {
        content = (
        <ScrollArea.Root className="w-full rounded overflow-hidden bg-white">
            <ScrollArea.Viewport className="w-full min-h-[200px] h-[calc(100vh-214px)] sm:h-full sm:max-h-[400px] rounded">
                {pcListContent}
            </ScrollArea.Viewport>
            <ScrollBar />
        </ScrollArea.Root>
        );
    } else {
        content = <RenderProcedures />
    }

    return content;
}

export default ListContent